import { gPanelTiers } from '../../../../shared/gPanel-tiers';
import { PageConfigItem } from '../../../../shared/pages-config';
import { GPanelContactsPermissions } from '../../../../utils/roles/client-roles';

import Contacts from '@mui/icons-material/Contacts';
import Sync from '@mui/icons-material/Sync';

export const GPanelContactsPagesConfig = {
  MyContacts: {
    name: 'My Contacts',
    link: 'my-contacts',
    value: 'gpanelContactsMyContacts',
    icon: Contacts,
    requiredPermission: '*',
    requiredPermissionDisplayValue: '*',
    roleGroup: 'gPanelContactsRoles',
    minimumTier: gPanelTiers.starter.rank,
    minimumTierDisplayValue: gPanelTiers.starter.displayValue,
  },
  OrganizationDirectory: {
    name: 'gPanel Directory',
    link: 'gpanel-directory',
    value: 'gpanelContactsOrganizationDirectory',
    icon: Contacts,
    requiredPermission: GPanelContactsPermissions.CanViewGPanelContacts.value,
    requiredPermissionDisplayValue:
      GPanelContactsPermissions.CanViewGPanelContacts.name,
    roleGroup: 'gPanelContactsRoles',
    minimumTier: gPanelTiers.starter.rank,
    minimumTierDisplayValue: gPanelTiers.starter.displayValue,
  },
  OrganizationLabels: {
    name: 'gPanel Labels',
    link: 'organization-labels',
    value: 'gpanelContactsOrganizationLabels',
    icon: Contacts,
    requiredPermission: GPanelContactsPermissions.CanViewGPanelContacts.value,
    requiredPermissionDisplayValue:
      GPanelContactsPermissions.CanViewGPanelContacts.name,
    roleGroup: 'gPanelContactsRoles',
    minimumTier: gPanelTiers.starter.rank,
    minimumTierDisplayValue: gPanelTiers.starter.displayValue,
  },
  ContactSyncs: {
    name: 'Contact Syncs',
    link: 'contact-syncs',
    value: 'gpanelContactsContactSyncs',
    icon: Sync,
    requiredPermission: GPanelContactsPermissions.ViewContactSyncs.value,
    requiredPermissionDisplayValue:
      GPanelContactsPermissions.ViewContactSyncs.name,
    roleGroup: 'gPanelContactsRoles',
    minimumTier: gPanelTiers.starter.rank,
    minimumTierDisplayValue: gPanelTiers.starter.displayValue,
  },
  NewContactSync: {
    name: 'New Contact Sync',
    link: 'create',
    value: 'gpanelContactsNewContactSync',
    icon: Sync,
    requiredPermission: GPanelContactsPermissions.CreateContactSync.value,
    requiredPermissionDisplayValue:
      GPanelContactsPermissions.CreateContactSync.name,
    roleGroup: 'gPanelContactsRoles',
    minimumTier: gPanelTiers.starter.rank,
    minimumTierDisplayValue: gPanelTiers.starter.displayValue,
  },
  EditContactSync: {
    name: 'Edit Contact Sync',
    link: 'edit',
    value: 'gpanelContactsNewContactSync',
    icon: Sync,
    requiredPermission: GPanelContactsPermissions.EditContactSync.value,
    requiredPermissionDisplayValue:
      GPanelContactsPermissions.EditContactSync.name,
    roleGroup: 'gPanelContactsRoles',
    minimumTier: gPanelTiers.starter.rank,
    minimumTierDisplayValue: gPanelTiers.starter.displayValue,
  },
  UserStatusContactSync: {
    name: 'Destination User Status',
    link: 'status',
    value: 'gpanelContactsUserStatusContactSync',
    icon: Sync,
    requiredPermission: '',
    requiredPermissionDisplayValue: '',
    roleGroup: 'gPanelContactsRoles',
    minimumTier: gPanelTiers.starter.rank,
    minimumTierDisplayValue: gPanelTiers.starter.displayValue,
  },
  TrashLabels: {
    name: 'Labels',
    link: 'trash-labels',
    value: 'gpanelContactsTrashLabels',
    icon: Contacts,
    requiredPermission: GPanelContactsPermissions.CanViewGPanelContacts.value,
    requiredPermissionDisplayValue:
      GPanelContactsPermissions.CanViewGPanelContacts.name,
    roleGroup: 'gPanelContactsRoles',
    minimumTier: gPanelTiers.starter.rank,
    minimumTierDisplayValue: gPanelTiers.starter.displayValue,
  },
  TrashContacts: {
    name: 'Contacts',
    link: 'trash-contacts',
    value: 'gpanelContactsTrashContacts',
    icon: Contacts,
    requiredPermission: GPanelContactsPermissions.CanViewGPanelContacts.value,
    requiredPermissionDisplayValue:
      GPanelContactsPermissions.CanViewGPanelContacts.name,
    roleGroup: 'gPanelContactsRoles',
    minimumTier: gPanelTiers.starter.rank,
    minimumTierDisplayValue: gPanelTiers.starter.displayValue,
  },
  ContactsDetails: {
    name: 'Contact Details',
    link: 'contacts',
    value: 'gpanelContactsDetails',
    icon: Contacts,
    hiddenFromSearch: false,
    requiredPermission: GPanelContactsPermissions.CanViewGPanelContacts.value,
    requiredPermissionDisplayValue:
      GPanelContactsPermissions.CanViewGPanelContacts.name,
    roleGroup: 'gPanelContactsRoles',
    minimumTier: gPanelTiers.starter.rank,
    minimumTierDisplayValue: gPanelTiers.starter.displayValue,
  },
  LabelsLogs: {
    name: 'Labels Logs',
    link: 'logs',
    value: 'gpanelContactsLabelsLogs',
    icon: Contacts,
    hiddenFromSearch: true,
    requiredPermission: GPanelContactsPermissions.ViewLogs.value,
    requiredPermissionDisplayValue: GPanelContactsPermissions.ViewLogs.name,
    roleGroup: 'gPanelContactsRoles',
    minimumTier: gPanelTiers.starter.rank,
    minimumTierDisplayValue: gPanelTiers.starter.displayValue,
  },
} as const satisfies Record<string, PageConfigItem>;
